// extracted by mini-css-extract-plugin
export var parcelRow = "_tu-0";